export const TICKET_MAX_BYTES = 10 * 1024 * 1024;
export const TICKET_MAX_LABEL = "10 MB";

export function utf8Bytes(value: string): number {
  return new TextEncoder().encode(value || "").length;
}

export function ticketPayloadBytes(title: string, description: string): number {
  return utf8Bytes(title) + utf8Bytes(description);
}

export function isEmptyHtml(html: string): boolean {
  const text = (html || "")
    .replace(/<img\b[^>]*>/gi, "IMG")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .trim();
  return text.length === 0;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}
